import { Pipe, PipeTransform } from '@angular/core';
import { TipoUsuario } from '../../enum/TipoUsuario';

@Pipe({
  name: 'tipoUsuario',
})
export class TipoUsuarioPipe implements PipeTransform {
  transform(tipoUsuario: TipoUsuario): string {
    return {
      [TipoUsuario.IziiAdmin]: 'IziiAdmin',
      [TipoUsuario.Admin]: 'Master',
      [TipoUsuario.Normal]: 'Normal',
    }[tipoUsuario];
  }
}
